import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { IDomain, IDomains } from './domains-model';

@Injectable()
export class DomainsService {
    constructor(
        private http: HttpClient
    ) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
    private static readonly ENDPOINT = 'domains';

    /** GET */
    public getDomains(): Observable<SuccessResponse<IDomains> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<IDomains>>(
                DomainsService.URL +
                DomainsService.ENDPOINT
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }
}
